import { STATUS_CODE_BY_ERROR_CODE } from 'constants/video/videoselfie';

import { ERROR } from 'constants/video/status';

export const getStatusCodeFromErrorCode = errorCode => {
    const statusCode = STATUS_CODE_BY_ERROR_CODE[errorCode];
    if (statusCode) return statusCode;

    return ERROR;
};
